import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { workbookCompare } from '../data/content';
export function WorkbookCompare() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="workbook" data-id="element-187" data-mp="3g4lwy1hkkxh8">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-188" data-mp="31biqap5io45a">
        <h2 id="workbook" className="font-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-189" data-mp="36boe1u8o16i3">
          ¿Qué agrega el Workbook Estratégico?
        </h2>
        <p className="mt-3 max-w-2xl text-[17px] text-ink/65" data-id="element-190" data-mp="2wesb041jdckx">
          La diferencia entre tener el sistema y ejecutarlo con una secuencia
          clara.
        </p>

        <div className="mt-9 overflow-hidden rounded-2xl border border-ink/10" data-id="element-191" data-mp="2ndu7rnyx993e">
          <div className="grid grid-cols-2 bg-ink/[0.04]" data-id="element-192" data-mp="2nfya41h6a01k">
            <p className="border-r border-ink/10 px-5 py-3.5 font-display text-sm font-bold uppercase tracking-wide text-ink/50" data-id="element-193" data-mp="gopbq744vj47">
              Sin Workbook
            </p>
            <p className="px-5 py-3.5 font-display text-sm font-bold uppercase tracking-wide text-leaf-dark" data-id="element-194" data-mp="3lqx5zp4vbvex">
              Con Workbook
            </p>
          </div>
          <div className="divide-y divide-ink/10" data-id="element-195" data-mp="3gqj8v24t25vo">
            {workbookCompare.map(row => <div key={row.con} className="grid grid-cols-2" data-id="element-196" data-mp="3ullctjq3dl5u">
                <p className="flex items-start gap-2.5 border-r border-ink/10 px-5 py-4 text-[15px] leading-snug text-ink/55" data-id="element-197" data-mp="3qjgjkm3k2qjq">
                  <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/30" aria-hidden="true" data-id="element-198" data-mp="32up14mfrpmk5" />
                  {row.sin}
                </p>
                <p className="flex items-start gap-2.5 px-5 py-4 text-[15px] font-medium leading-snug text-ink" data-id="element-199" data-mp="3bqwkbwjj137k">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf-dark" aria-hidden="true" data-id="element-200" data-mp="r31r701x5dk0" />
                  {row.con}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}